import { IFilterResource } from "@/services/resource-service/entity/ResourceEntity";


export enum EFieldFilter {
    Location,
    Category,
    Search
}
export interface IFilterResourceProps {
    updateFilterResource?: (filter: IFilterResource) => void;
    hiddenField?: EFieldFilter[]
}